import React from 'react';
import PropTypes from 'prop-types';

import { Tooltip } from '@folio/stripes/components';

import { ActionItem } from '../../../../common';
import { ICONS } from '../../../../../constants';

const ActionsDropdown = ({
  onToggle,
  tooltipMessage,
  disabled,
  onEdit,
  onDelete,
}) => (
  <>
    <ActionItem
      icon={ICONS.EDIT}
      id="editTaskAction"
      messageId="action.edit"
      onClickHandler={onEdit}
      onToggle={onToggle}
    />
    <Tooltip
      id="delete-tooltip"
      text={tooltipMessage}
    >
      {({ ref, ariaIds }) => (
        <div
          ref={disabled ? ref : null}
          aria-labelledby={ariaIds.text}
        >
          <ActionItem
            disabled={disabled}
            icon={ICONS.DELETE}
            id="deleteTaskAction"
            messageId="action.delete"
            onClickHandler={onDelete}
            onToggle={onToggle}
          />
        </div>
      )}
    </Tooltip>
  </>
);

ActionsDropdown.propTypes = {
  disabled: PropTypes.bool.isRequired,
  tooltipMessage: PropTypes.node.isRequired,
  onDelete: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onToggle: PropTypes.func.isRequired,
};

export default ActionsDropdown;
